// import axios from "../../../axios";
import React, { useState } from "react";
import axios from "../../../../axios";
const DeleteQueryLib = ({
  setDeleteQuery1,
  queryId,
  userId,
  setComponentRerenderFlag,
}) => {
  // let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  // let user_id = teacher_id;
  const handleDeleteQuery = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(`/query/delete/${queryId}`, {
        data: { user_id: userId },
      });
      //   res && setQuery([]);
      //   setDelQuery(true);
      res && setComponentRerenderFlag((prevFlag) => !prevFlag);
      res && setDeleteQuery1();
      // res && window.location.reload();
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };
  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={(e) => setDeleteQuery1()}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to delete this Query?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={() => {
                handleDeleteQuery();
              }}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              autoFocus
              onClick={(e) => setDeleteQuery1()}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteQueryLib;
